import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SvgCommonModule } from '../../../../shared/svg/svg-common.module';

import { ConditionsComponent } from './conditions.component';

@NgModule({
	imports: [
		CommonModule,
		SvgCommonModule,
	],
	declarations: [ConditionsComponent],
	exports: [ConditionsComponent],
})
export class ConditionsModule { }
